var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "oneRef" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3 col-lg-2" }, [
          _vm.mainImage
            ? _c("img", {
                staticClass: "lazyload img-fluid",
                attrs: { "data-src": _vm.mainImage, alt: _vm.title }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-9 col-lg-10" }, [
          _c("strong", [
            _vm.referenceTitle
              ? _c("span", [_vm._v(_vm._s(_vm.referenceTitle) + " - ")])
              : _vm._e(),
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(
            "\n                Réf. " +
              _vm._s(_vm.referenceCode) +
              "\n\n                "
          ),
          "site.repository.product_reference" === _vm.type ||
          "site.repository.fidelity_gift" === _vm.type
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-5" }, [
                  "site.repository.product_reference" === _vm.type
                    ? _c("div", { staticClass: "prix" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm._f("moneyFormat")(
                                _vm.discountedUnitPrice != _vm.unitPrice
                                  ? _vm.discountedUnitPrice
                                  : _vm.unitPrice
                              )
                            ) +
                            "\n                            "
                        ),
                        _vm.discountedUnitPrice != _vm.unitPrice
                          ? _c("del", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm._f("moneyFormat")(_vm.unitPrice)) +
                                  "\n                            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.advantageName &&
                        _vm.discountedUnitPrice != _vm.unitPrice
                          ? _c("span", { staticClass: "advantage" }, [
                              _vm._v("(" + _vm._s(_vm.advantageName) + ")")
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  "site.repository.fidelity_gift" === _vm.type
                    ? _c("div", { staticClass: "prix" }, [
                        _vm._v(
                          _vm._s(_vm.unitFidelityPoint) + " points fidélité"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-lg-7" }, [
                  "site.repository.product_reference" === _vm.type
                    ? _c(
                        "div",
                        [
                          _c("ponroy-cart-quantity", {
                            model: {
                              value: _vm.quantity,
                              callback: function($$v) {
                                _vm.quantity = $$v
                              },
                              expression: "quantity"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  "site.repository.fidelity_gift" === _vm.type
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "qty form-group row no-gutters" },
                          [
                            _c(
                              "label",
                              { staticClass: "col-5 col-lg-4 col-form-label" },
                              [_vm._v("Quantité ")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-1 col-lg-1" }, [
                              _c(
                                "span",
                                { staticClass: "form-control float-left" },
                                [_vm._v(_vm._s(_vm.quantity))]
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-5" }, [
              _c("small", [
                "site.repository.product_reference" === _vm.type
                  ? _c(
                      "a",
                      {
                        attrs: { href: "" },
                        on: {
                          click: function(e) {
                            return _vm.edit(e)
                          }
                        }
                      },
                      [_vm._v("Modifier")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    attrs: { href: "" },
                    on: {
                      click: function(e) {
                        return _vm.remove(e)
                      }
                    }
                  },
                  [_vm._v("Supprimer")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-7 text-right" }, [
              "site.repository.product_reference" === _vm.type
                ? _c("div", { staticClass: "total" }, [
                    _vm._v(_vm._s(_vm._f("moneyFormat")(_vm.total)))
                  ])
                : _vm._e(),
              _vm._v(" "),
              "site.repository.gift" === _vm.type
                ? _c("div", { staticClass: "total" }, [_vm._v("OFFERT")])
                : _vm._e(),
              _vm._v(" "),
              "site.repository.fidelity_gift" === _vm.type
                ? _c("div", { staticClass: "total" }, [
                    _vm._v(_vm._s(_vm.total) + " points")
                  ])
                : _vm._e()
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e34d872", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e34d872","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartItem.vue
// module id = 504
// module chunks = 1